// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__s68p4","info":"Note_info__ppFdB","note":"Note_note__27i65","actions":"Note_actions__sNyPD"};